import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import logo from '../../images/site-logo.png';

const Header = () => {
  const setApp = useDispatch();
  const { first_name, role, photo } = useSelector(s => s.auth);

  useEffect(() => {
    setApp({
      type: '_AUTH_LOGGED',
      payload: window.auth
    });
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <a id="logo" href="/" target="_blank">
        <img src={logo} alt="Logo" />
      </a>
      <a className="navbar-brand" href="/">
        WILDMEAT Database Explorer
      </a>
      <button
        type="button" 
        className="navbar-toggler"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      {

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                About
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setApp({ type: '_POPUP', payload: ['popup', 'About'] });
                  }}
                >
                  About the database
                </a>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setApp({
                      type: '_POPUP',
                      payload: ['popup', 'How to use the database']
                    });
                  }}
                >
                  Guidelines for Database Use
                </a>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setApp({
                      type: '_POPUP',
                      payload: ['popup', 'How to contribute']
                    });
                  }}
                >
                  How to contribute
                </a>
              </div>
            </li>
            <li>
              <a
                className="nav-link"
                href="/#partners"
                onClick={(e) => {
                  e.preventDefault()
                  setApp({type:'_POPUP',payload:['popup','Partners']});
                }}
              >
                Partners
              </a>
            </li>
            {
              first_name
                ? (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="loggedDropdown"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {
                          photo
                            ? (
                                <img
                                  style={{
                                    width: 16,
                                    height: 16,
                                    borderRadius: '100%',
                                    marginTop: -4
                                  }}
                                  src={`/photo/${photo}`}
                                />
                              )
                            : <i className="fa fa-user-circle" />
                        } {first_name}
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="loggedDropdown"
                      >
                        <a
                          id="go-to-member-area"
                          className="dropdown-item"
                          href="/member"
                        >
                          <i className="fa fa-dashboard"/>
                          {role === 'ROLE_USER' ? ' Member area' : ' Dashboard'}
                        </a>
                        <a
                          className="dropdown-item"
                          href="/member/account"
                        >
                          <i className="fa fa-sliders" />
                          {' Account'}
                        </a>
                        <a
                          className="dropdown-item"
                          href="/logout"
                        >
                          <i className="fa fa-sign-out"/>
                          {' Logout'}
                        </a>
                      </div>
                    </li>
                  )
                : (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="unloggedDropdown"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Member
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="unloggedDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e)=>{
                            e.preventDefault();
                            setApp({
                              type: '_POPUP',
                              payload: ['popup', 'Login']
                            });
                          }}
                        >
                          <i className="fa fa-sign-in"/> Login
                        </a>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e)=>{
                            e.preventDefault()
                            setApp({
                              type: '_POPUP',
                              payload: ['popup', 'Register']
                            });
                          }}
                        >
                          <i className="fa fa-pencil-square-o"/> Sign up
                        </a>
                      </div>
                    </li>
                  )
            }
          </ul>
        </div>
      }
    </nav>
  );
};

export default Header;
